
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/mc-header-finance/index.vue"
}
